import { Alert, Button, Flex, Space, Typography } from 'antd'
import { X } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const { Text } = Typography

type Props = {
  token: string
  onDismiss: () => void
}

/**
 * One-time secret reveal shown right after a credential is created (or
 * rotated). The token comes from router state; reloading the page clears it,
 * matching the "show only once" security model — the banner never re-appears
 * on its own after that.
 */
export const TokenRevealBanner = ({ token, onDismiss }: Props) => {
  const { t } = useTranslation()

  return (
    <Alert
      type="warning"
      showIcon
      closable={false}
      title={t('workspace.credentials.tokenReveal.title')}
      description={
        <Flex vertical gap={12} style={{ marginTop: 4 }}>
          <Text>{t('workspace.credentials.tokenReveal.body')}</Text>
          <Text
            code
            copyable={{ text: token }}
            style={{
              display: 'block',
              wordBreak: 'break-all',
              fontSize: 12
            }}
          >
            {token}
          </Text>
          <Space>
            <Button size="small" icon={<X size={14} />} onClick={onDismiss}>
              {t('workspace.credentials.tokenReveal.done')}
            </Button>
          </Space>
        </Flex>
      }
    />
  )
}
